import { createSlice } from "@reduxjs/toolkit";

const initialState ={
isdloading:false,
dstatus:"",
dmessage:""
};

const userRoleDeleteSlice = createSlice({
    name:"userRoleDelete",
    initialState:initialState,
    reducers:{
        deleteRolePending:(state,action) => {
            state.isdloading=true;
            state.dstatus="";
        },
        deleteRoleSuccess:(state,{payload}) => {
            state.isdloading=false;
            state.dstatus="success";
            state.dmessage="User Role Successfully Deleted";
        },
        deleteRoleFail:(state,{payload}) => {
            state.isdloading=false;
            state.dstatus="fail";
           // console.log('slice '+payload);
            state.dmessage=payload;
        },
        reset: () => initialState


    }
});

const {reducer,actions} = userRoleDeleteSlice;
export const{deleteRolePending,deleteRoleSuccess,deleteRoleFail}=actions;
export default reducer;

